module.exports = __webpack_public_path__ + "static/nautical1-76b857210b58d3028105ede62728ed38.png";